// cSpell:ignore andor, decreasedrom, lowerleg, upperarm

import { createCodeableConcept } from '../../types/api/chart-data/exam-fields-map';

export const TelemedExamConfig = {
  general: {
    label: 'telemed.exam.labels.general',
    components: {
      normal: {
        alert: {
          label: 'telemed.exam.labels.alert',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Mental alertness (observable entity)'),
        },
        awake: {
          label: 'telemed.exam.labels.awake',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Awake (finding)'),
        },
        calm: {
          label: 'telemed.exam.labels.calm',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Feeling calm (finding)'),
        },
        'well-hydrated': {
          label: 'telemed.exam.labels.wellHydrated',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Hydration status (observable entity)'),
        },
        'moist-mucous-membrane': {
          label: 'telemed.exam.labels.mmm',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Moist oral mucosa (finding)'),
        },
        'distress-none': {
          label: 'telemed.exam.labels.noDistress',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Distress (finding)'),
        },
        'playful-and-active': {
          label: 'telemed.exam.labels.playfulAndActive',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Does play (finding)'),
        },
      },
      abnormal: {
        'tired-appearing': {
          label: 'telemed.exam.labels.tiredAppearing',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Tired (finding)'),
        },
        'ill-appearing': {
          label: 'telemed.exam.labels.illAppearing',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Illness (finding)'),
        },
        fussy: {
          label: 'telemed.exam.labels.fussy',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Feeling irritable (finding)'),
        },
        'dry-mucous-membranes': {
          label: 'telemed.exam.labels.dryMucousMembranes',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Mucous membrane dryness (finding)'),
        },
        'sunken-eye': {
          label: 'telemed.exam.labels.sunkenEyes',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Sunken eyes (finding)'),
        },
        distress: {
          label: 'telemed.exam.labels.distress',
          placeholder: 'telemed.exam.labels.distressDegree',
          type: 'dropdown',
          components: {
            'mild-distress': {
              label: 'telemed.exam.labels.mild',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Distress (finding)'),
            },
            'moderate-distress': {
              label: 'telemed.exam.labels.moderate',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Distress (finding)'),
            },
            'severe-distress': {
              label: 'telemed.exam.labels.severe',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Distress (finding)'),
            },
          },
        },
      },
      comment: {
        'general-comment': {
          label: 'telemed.exam.labels.generalComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Entire body as a whole (body structure)'),
        },
      },
    },
  },
  head: {
    label: 'telemed.exam.labels.head',
    components: {
      normal: {
        normocephaly: {
          label: 'telemed.exam.labels.normocephaly',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal (qualifier value)'),
        },
        atraumatic: {
          label: 'telemed.exam.labels.atraumatic',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'No traumatic injury (situation)'),
        },
      },
      abnormal: {},
      comment: {
        'head-comment': {
          label: 'telemed.exam.labels.headComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Finding of head region (finding)'),
        },
      },
    },
  },
  eyes: {
    label: 'telemed.exam.labels.eyes',
    components: {
      normal: {
        'pupils-symmetric': {
          label: 'telemed.exam.labels.pupilsSymmetric',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Pupils equal (finding)'),
        },
        eomi: {
          label: 'telemed.exam.labels.eomi',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal ocular motility (finding)'),
        },
        'right-eye-normal': {
          label: 'telemed.exam.labels.rightEyeNormal',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal eye proper (finding)'),
        },
        'left-eye-normal': {
          label: 'telemed.exam.labels.leftEyeNormal',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal eye proper (finding)'),
        },
      },
      abnormal: {
        'pupils-asymmetric': {
          label: 'telemed.exam.labels.pupilsAsymmetric',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Pupil finding (finding)'),
        },
        'right-eye': {
          label: 'telemed.exam.labels.rightEye',
          type: 'column',
          components: {
            'right-eye-injected': {
              label: 'telemed.exam.labels.injected',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Injection of caruncle of eye (finding)'),
            },
            'right-eye-discharge': {
              label: 'telemed.exam.labels.discharge',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Discharge from eye (finding)'),
            },
            'right-eye-watering': {
              label: 'telemed.exam.labels.watering',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Watery eye (finding)'),
            },
            'right-eye-puffy-eyelids': {
              label: 'telemed.exam.labels.puffyEyelids',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Swelling of eyelid (finding)'),
            },
            'right-eye-small-round-mass-in-eyelid': {
              label: 'telemed.exam.labels.smallRoundMassInEyelid',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Lump in eyelid (finding)'),
            },
          },
        },
        'left-eye': {
          label: 'telemed.exam.labels.leftEye',
          type: 'column',
          components: {
            'left-eye-injected': {
              label: 'telemed.exam.labels.injected',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Injection of caruncle of eye (finding)'),
            },
            'left-eye-discharge': {
              label: 'telemed.exam.labels.discharge',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Discharge from eye (finding)'),
            },
            'left-eye-watering': {
              label: 'telemed.exam.labels.watering',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Watery eye (finding)'),
            },
            'left-eye-puffy-eyelids': {
              label: 'telemed.exam.labels.puffyEyelids',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Swelling of eyelid (finding)'),
            },
            'left-eye-small-round-mass-in-eyelid': {
              label: 'telemed.exam.labels.smallRoundMassInEyelid',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Lump in eyelid (finding)'),
            },
          },
        },
      },
      comment: {
        'eyes-comment': {
          label: 'telemed.exam.labels.eyesComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Eye / vision finding (finding)'),
        },
      },
    },
  },
  nose: {
    label: 'telemed.exam.labels.nose',
    components: {
      normal: {
        'no-drainage': {
          label: 'telemed.exam.labels.noDrainage',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Nasal discharge (finding)'),
        },
      },
      abnormal: {
        'clear-rhinorrhea': {
          label: 'telemed.exam.labels.clearRhinorrhea',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Nasal discharge (finding)'),
        },
        'purulent-discharge': {
          label: 'telemed.exam.labels.purulentDischarge',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Mucopurulent discharge from nose (finding)'),
        },
      },
      comment: {
        'nose-comment': {
          label: 'telemed.exam.labels.noseComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Nose finding (finding)'),
        },
      },
    },
  },
  ears: {
    label: 'telemed.exam.labels.ears',
    components: {
      normal: {
        'normal-ear-right': {
          label: 'telemed.exam.labels.rightEarNormal',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Ear normal (finding)'),
        },
        'normal-ear-left': {
          label: 'telemed.exam.labels.leftEarNormal',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Ear normal (finding)'),
        },
      },
      abnormal: {
        'right-ear': {
          label: 'telemed.exam.labels.rightEar',
          type: 'column',
          components: {
            'erythema-ear-right': {
              label: 'telemed.exam.labels.erythema',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Erythema (finding)'),
            },
            'swelling-ear-right': {
              label: 'telemed.exam.labels.swelling',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Swelling of ear (finding)'),
            },
            'pain-with-movement-of-pinna-ear-right': {
              label: 'telemed.exam.labels.painWithMovementOfPinna',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Tenderness of ear structure (finding)'),
            },
            'drainage-from-ear-canal-right': {
              label: 'telemed.exam.labels.drainageFromEarCanal',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Ear discharge (finding)'),
            },
            'clear-discharge-ear-right': {
              label: 'telemed.exam.labels.clearDischarge',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Ear discharge (finding)'),
            },
          },
        },
        'left-ear': {
          label: 'telemed.exam.labels.leftEar',
          type: 'column',
          components: {
            'erythema-ear-left': {
              label: 'telemed.exam.labels.erythema',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Erythema (finding)'),
            },
            'swelling-ear-left': {
              label: 'telemed.exam.labels.swelling',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Swelling of ear (finding)'),
            },
            'pain-with-movement-of-pinna-ear-left': {
              label: 'telemed.exam.labels.painWithMovementOfPinna',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Tenderness of ear structure (finding)'),
            },
            'drainage-from-ear-canal-left': {
              label: 'telemed.exam.labels.drainageFromEarCanal',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Ear discharge (finding)'),
            },
            'clear-discharge-ear-left': {
              label: 'telemed.exam.labels.clearDischarge',
              defaultValue: false,
              type: 'checkbox',
              code: createCodeableConcept(undefined, 'Ear discharge (finding)'),
            },
          },
        },
      },
      comment: {
        'ears-comment': {
          label: 'telemed.exam.labels.earsComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Ear finding (finding)'),
        },
      },
    },
  },
  mouth: {
    label: 'telemed.exam.labels.mouth',
    components: {
      normal: {
        'mouth-normal': {
          label: 'telemed.exam.labels.noVisibleAbnormalities',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'No mouth problem (situation)'),
        },
        'mouth-moist-mucous-membrane': {
          label: 'telemed.exam.labels.mmm',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Moist oral mucosa (finding)'),
        },
        'oropharynx-clear': {
          label: 'telemed.exam.labels.oropharynxClearWithNoErythemaNoLesionsOrExudate',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'No mouth problem (situation)'),
        },
        'uvula-midline': {
          label: 'telemed.exam.labels.uvulaMidline',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Deviation of uvula (finding)'),
        },
        'tonsils-symmetric-and-not-enlarged': {
          label: 'telemed.exam.labels.tonsilsSymmetricAndNotEnlarged',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Tonsil asymmetry (finding)'),
        },
        'normal-voice': {
          label: 'telemed.exam.labels.normalVoice',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal voice (finding)'),
        },
      },
      abnormal: {
        'mouth-dry-mucous-membranes': {
          label: 'telemed.exam.labels.dryMucousMembranes',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Open mouth (finding)'),
        },
        'erythema-of-pharynx': {
          label: 'telemed.exam.labels.erythemaOfPharynx',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Erythema (finding)'),
        },
        'white-patches-on-tongue-andor-buccal-mucosa-that-do-not-wipe-off': {
          label: 'telemed.exam.labels.whitePatchesOnTongueAndOrBuccalMucosaThatDoNotWipeOff',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Coating of mucous membrane of tongue (finding)'),
        },
        'strawberry-tongue': {
          label: 'telemed.exam.labels.strawberryTongue',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Strawberry tongue (disorder)'),
        },
        'uvula-deviated': {
          label: 'telemed.exam.labels.uvulaDeviated',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Deviation of uvula (finding)'),
        },
        'tonsils-erythematous': {
          label: 'telemed.exam.labels.tonsilsErythematous',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Acute erythematous tonsillitis (disorder)'),
        },
        'exudate-on-tonsils': {
          label: 'telemed.exam.labels.exudateOnTonsils',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Exudate on tonsils (finding)'),
        },
        'hoarse-voice': {
          label: 'telemed.exam.labels.hoarseVoice',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Hoarse (finding)'),
        },
        'hot-potato-voice': {
          label: 'telemed.exam.labels.hotPotatoVoice',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'NOT REAL CODE Hot potato voice (finding)'),
        },
      },
      comment: {
        'mouth-comment': {
          label: 'telemed.exam.labels.mouthComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Finding of mouth region (finding)'),
        },
      },
    },
  },
  neck: {
    label: 'telemed.exam.labels.neck',
    components: {
      normal: {
        'supple-neck': {
          label: 'telemed.exam.labels.supple',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Supple (qualifier value)'),
        },
        'moves-in-all-directions': {
          label: 'telemed.exam.labels.movesInAllDirections',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal movement of neck (finding)'),
        },
      },
      abnormal: {},
      comment: {
        'neck-comment': {
          label: 'telemed.exam.labels.neckComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Finding of neck region (finding)'),
        },
      },
    },
  },
  chest: {
    label: 'telemed.exam.labels.chest',
    components: {
      normal: {
        'normal-respiratory-effort': {
          label: 'telemed.exam.labels.normalRespiratoryEffort',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal respiratory effort (finding)'),
        },
        'no-tachypnea': {
          label: 'telemed.exam.labels.noTachypnea',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Respiratory rate normal (finding)'),
        },
        'no-retractions': {
          label: 'telemed.exam.labels.noRetractions',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Chest wall retraction (finding)'),
        },
        'no-conversational-dyspnea': {
          label: 'telemed.exam.labels.noConversationalDyspnea',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'No breathlessness (situation)'),
        },
      },
      abnormal: {
        tachypnea: {
          label: 'telemed.exam.labels.tachypnea',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Tachypnea (finding)'),
        },
        'suprasternal-retractions': {
          label: 'telemed.exam.labels.suprasternalRetractions',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Chest wall retraction (finding)'),
        },
        'intercostal-retractions': {
          label: 'telemed.exam.labels.intercostalRetractions',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Chest wall retraction (finding)'),
        },
        'subcostal-retractions': {
          label: 'telemed.exam.labels.subcostalRetractions',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Chest wall retraction (finding)'),
        },
        'abdominal-breathing': {
          label: 'telemed.exam.labels.abdominalBreathing',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Diaphragmatic breathing (finding)'),
        },
        grunting: {
          label: 'telemed.exam.labels.grunting',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Grunting respiration (finding)'),
        },
        'nasal-flaring': {
          label: 'telemed.exam.labels.nasalFlaring',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Nasal flaring (finding)'),
        },
        wheeze: {
          label: 'telemed.exam.labels.audibleWheeze',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Wheezing (finding)'),
        },
        'barky-cough': {
          label: 'telemed.exam.labels.barkyCough',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Barking cough (finding)'),
        },
        'stridor-with-each-breath': {
          label: 'telemed.exam.labels.stridorWithEachBreath',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Stridor (finding)'),
        },
      },
      comment: {
        'chest-comment': {
          label: 'telemed.exam.labels.chestComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Problem of chest (finding)'),
        },
      },
    },
  },
  back: {
    label: 'telemed.exam.labels.back',
    components: {
      normal: {
        'back-normal': {
          label: 'telemed.exam.labels.normal',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal (qualifier value)'),
        },
        'able-to-flex-and-extend-back-and-move-side-to-side': {
          label: 'telemed.exam.labels.ableToFlexAndExtendBackAndTwistSideToSide',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Range of joint movement (observable entity)'),
        },
      },
      abnormal: {
        'cva-tenderness': {
          label: 'telemed.exam.labels.cvaTenderness',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Renal angle tenderness (finding)'),
        },
      },
      comment: {
        'back-comment': {
          label: 'telemed.exam.labels.backComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Finding of back (finding)'),
        },
      },
    },
  },
  skin: {
    label: 'telemed.exam.labels.skin',
    components: {
      normal: {
        'no-rashes': {
          label: 'telemed.exam.labels.noRashes',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Skin appearance normal (finding)'),
        },
      },
      abnormal: {
        rashes: {
          label: 'telemed.exam.labels.rashes',
          type: 'form',
          components: {
            consistentWithViralExam: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Macular eruption (disorder)'),
            },
            consistentWithInsectBites: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Insect bite - wound (disorder)'),
            },
            consistentWithUrticaria: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Urticaria (disorder)'),
            },
            consistentWithCoxsackievirus: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Coxsackie virus exanthem (disorder)'),
            },
            consistentWithIrritantDiaperRash: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Diaper rash (disorder)'),
            },
            consistentWithRingworm: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Dermatophytosis (disorder)'),
            },
            consistentWithImpetigo: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Impetigo (disorder)'),
            },
            consistentWithFifthsDisease: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Eruption of skin of face (disorder)'),
            },
            consistentWithAtopicDermatitis: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Atopic dermatitis (disorder)'),
            },
            consistentWithParonychia: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Paronychia (disorder)'),
            },
            consistentWithPoisonIvyContactDermatitis: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Hedera helix poisoning (disorder)'),
            },
            consistentWithTineaCapitis: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Tinea capitis (disorder)'),
            },
            consistentWithPityriasisRosea: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Pityriasis rosea (disorder)'),
            },
            consistentWithLymeEcm: {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Lyme disease (disorder)'),
            },
          },
          fields: {
            rashes: {
              label: 'telemed.exam.labels.rashes',
              type: 'dropdown',
              options: {
                consistentWithViralExam: {
                  label: 'telemed.exam.labels.consistentWithViralExam',
                },
                consistentWithInsectBites: {
                  label: 'telemed.exam.labels.consistentWithInsectBites',
                },
                consistentWithUrticaria: {
                  label: 'telemed.exam.labels.consistentWithUrticaria',
                },
                consistentWithCoxsackievirus: {
                  label: 'telemed.exam.labels.consistentWithCoxsackievirus',
                },
                consistentWithIrritantDiaperRash: {
                  label: 'telemed.exam.labels.consistentWithIrritantDiaperRash',
                },
                consistentWithRingworm: {
                  label: 'telemed.exam.labels.consistentWithRingworm',
                },
                consistentWithImpetigo: {
                  label: 'telemed.exam.labels.consistentWithImpetigo',
                },
                consistentWithFifthsDisease: {
                  label: 'telemed.exam.labels.consistentWithFifthsDisease',
                },
                consistentWithAtopicDermatitis: {
                  label: 'telemed.exam.labels.consistentWithAtopicDermatitis',
                },
                consistentWithParonychia: {
                  label: 'telemed.exam.labels.consistentWithParonychia',
                },
                consistentWithPoisonIvyContactDermatitis: {
                  label: 'telemed.exam.labels.consistentWithPoisonIvyContactDermatitis',
                },
                consistentWithTineaCapitis: {
                  label: 'telemed.exam.labels.consistentWithTineaCapitis',
                },
                consistentWithPityriasisRosea: {
                  label: 'telemed.exam.labels.consistentWithPityriasisRosea',
                },
                consistentWithLymeEcm: {
                  label: 'telemed.exam.labels.consistentWithLymeEcm',
                },
              },
            },
            description: {
              label: 'telemed.exam.labels.description',
              type: 'text',
            },
          },
        },
      },
      comment: {
        'skin-comment': {
          label: 'telemed.exam.labels.skinComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Skin finding (finding)'),
        },
      },
    },
  },
  abdomen: {
    label: 'telemed.exam.labels.abdomen',
    components: {
      normal: {
        'normal-appearing-on-parental-exam': {
          label: 'telemed.exam.labels.normalAppearingOnParentalExam',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Abdomen examined - no abnormality detected (finding)'),
        },
        'non-tender-on-parental-exam': {
          label: 'telemed.exam.labels.nonTenderOnParentalExam',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Abdominal tenderness absent (situation)'),
        },
        'able-to-jump-up-down-without-abdominal-pain': {
          label: 'telemed.exam.labels.ableToJumpUpDownWithoutAbdominalPain',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Able to jump (finding)'),
        },
      },
      abnormal: {
        tender: {
          label: 'telemed.exam.labels.tender',
          placeholder: 'telemed.exam.labels.tenderLocation',
          type: 'dropdown',
          components: {
            'left-lower-quadrant-abdomen': {
              label: 'telemed.exam.labels.leftLowerQuadrantAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of left lower quadrant of abdomen (body structure)'),
            },
            'right-lower-quadrant-abdomen': {
              label: 'telemed.exam.labels.rightLowerQuadrantAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of right lower quadrant of abdomen (body structure)'),
            },
            'right-upper-quadrant-abdomen': {
              label: 'telemed.exam.labels.rightUpperQuadrantAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of right upper quadrant of abdomen (body structure)'),
            },
            'left-upper-quadrant-abdomen': {
              label: 'telemed.exam.labels.leftUpperQuadrantAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of left upper quadrant of abdomen (body structure)'),
            },
            'epigastric-region-abdomen': {
              label: 'telemed.exam.labels.epigastricRegionAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Epigastric region structure (body structure)'),
            },
            'left-abdominal-lumbar-region-abdomen': {
              label: 'telemed.exam.labels.leftAbdominalLumbarRegionAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of left abdominal lumbar region (body structure)'),
            },
            'right-abdominal-lumbar-region-abdomen': {
              label: 'telemed.exam.labels.rightAbdominalLumbarRegionAbdomen',
              defaultValue: false,
              type: 'option',
              code: createCodeableConcept(undefined, 'Structure of right abdominal lumbar region (body structure)'),
            },
          },
        },
        'not-able-to-jump-up-down-due-to-abdominal-pain': {
          label: 'telemed.exam.labels.notAbleToJumpUpDownDueToAbdominalPain',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Able to jump (finding)'),
        },
      },
      comment: {
        'abdomen-comment': {
          label: 'telemed.exam.labels.abdomenComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Finding of abdomen (finding)'),
        },
      },
    },
  },
  musculoskeletal: {
    label: 'telemed.exam.labels.musculoskeletal',
    components: {
      normal: {
        'moving-extemities-equally': {
          label: 'telemed.exam.labels.movingExtemitiesEqually',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Normal muscle function (finding)'),
        },
        'normal-gait': {
          label: 'telemed.exam.labels.normalGait',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Gait normal (finding)'),
        },
        'normal-rom': {
          label: 'telemed.exam.labels.normalRom',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Range of joint movement (observable entity)'),
        },
        'no-swelling': {
          label: 'telemed.exam.labels.noSwelling',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Swelling (finding)'),
        },
        'no-bruising': {
          label: 'telemed.exam.labels.noBruising',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
        },
        'no-deformity': {
          label: 'telemed.exam.labels.noDeformity',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Deformity (finding)'),
        },
      },
      abnormal: {
        abnormal: {
          label: 'telemed.exam.labels.abnormal',
          type: 'form',
          components: {
            'left-finger-index-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-finger-index-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-finger-middle-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-finger-middle-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-finger-ring-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-finger-ring-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-finger-little-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-finger-little-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-finger-thumb-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-finger-thumb-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-hand-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-hand-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-foot-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-foot-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-toe-great-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-toe-great-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-toe-second-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-toe-second-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-toe-third-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-toe-third-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-toe-fourth-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-toe-fourth-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-toe-fifth-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-toe-fifth-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-wrist-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-wrist-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-forearm-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-forearm-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-elbow-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-elbow-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-upperarm-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-upperarm-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-shoulder-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-shoulder-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-knee-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-knee-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-lowerleg-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-lowerleg-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-ankle-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'right-ankle-swelling': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Swelling (finding)'),
            },
            'left-finger-index-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-finger-index-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-finger-middle-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-finger-middle-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-finger-ring-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-finger-ring-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-finger-little-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-finger-little-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-finger-thumb-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-finger-thumb-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-hand-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-hand-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-foot-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-foot-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-toe-great-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-toe-great-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-toe-second-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-toe-second-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-toe-third-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-toe-third-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-toe-fourth-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-toe-fourth-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-toe-fifth-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-toe-fifth-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-wrist-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-wrist-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-forearm-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-forearm-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-elbow-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-elbow-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-upperarm-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-upperarm-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-shoulder-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-shoulder-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-knee-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-knee-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-lowerleg-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-lowerleg-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-ankle-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'right-ankle-deformity': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Deformity (finding)'),
            },
            'left-finger-index-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-finger-index-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-finger-middle-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-finger-middle-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-finger-ring-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-finger-ring-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-finger-little-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-finger-little-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-finger-thumb-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-finger-thumb-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-hand-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-hand-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-foot-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-foot-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-toe-great-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-toe-great-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-toe-second-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-toe-second-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-toe-third-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-toe-third-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-toe-fourth-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-toe-fourth-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-toe-fifth-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-toe-fifth-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-wrist-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-wrist-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-forearm-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-forearm-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-elbow-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-elbow-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-upperarm-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-upperarm-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-shoulder-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-shoulder-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-knee-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-knee-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-lowerleg-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-lowerleg-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-ankle-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'right-ankle-bruising': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Finding related to bruising (finding)'),
            },
            'left-finger-index-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-finger-index-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-finger-middle-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-finger-middle-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-finger-ring-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-finger-ring-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-finger-little-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-finger-little-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-finger-thumb-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-finger-thumb-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-hand-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-hand-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-foot-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-foot-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-toe-great-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-toe-great-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-toe-second-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-toe-second-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-toe-third-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-toe-third-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-toe-fourth-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-toe-fourth-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-toe-fifth-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-toe-fifth-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-wrist-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-wrist-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-forearm-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-forearm-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-elbow-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-elbow-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-upperarm-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-upperarm-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-shoulder-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-shoulder-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-knee-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-knee-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-lowerleg-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-lowerleg-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-ankle-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'right-ankle-ableToBearWeight': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Weight-bearing (finding)'),
            },
            'left-finger-index-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'right-finger-index-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'left-finger-middle-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'right-finger-middle-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'left-finger-ring-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'right-finger-ring-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'left-finger-little-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'right-finger-little-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of finger movement (finding)'),
            },
            'left-finger-thumb-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of thumb movement (finding)'),
            },
            'right-finger-thumb-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of thumb movement (finding)'),
            },
            'left-hand-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-hand-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-foot-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of foot movement (finding)'),
            },
            'right-foot-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of foot movement (finding)'),
            },
            'left-toe-great-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-toe-great-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-toe-second-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-toe-second-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-toe-third-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-toe-third-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-toe-fourth-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-toe-fourth-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-toe-fifth-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-toe-fifth-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-wrist-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of wrist movement (finding)'),
            },
            'right-wrist-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of wrist movement (finding)'),
            },
            'left-forearm-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-forearm-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-elbow-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of elbow movement (finding)'),
            },
            'right-elbow-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of elbow movement (finding)'),
            },
            'left-upperarm-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-upperarm-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-shoulder-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-shoulder-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-knee-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-knee-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-lowerleg-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'right-lowerleg-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Limitation of joint movement (finding)'),
            },
            'left-ankle-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of ankle movement (finding)'),
            },
            'right-ankle-decreasedrom': {
              defaultValue: false,
              type: 'form-element',
              code: createCodeableConcept(undefined, 'Decreased range of ankle movement (finding)'),
            },
          },
          fields: {
            side: {
              label: 'telemed.exam.labels.side',
              type: 'radio',
              options: {
                left: {
                  label: 'telemed.exam.labels.left',
                },
                right: {
                  label: 'telemed.exam.labels.right',
                },
              },
            },
            bodyPart: {
              label: 'telemed.exam.labels.bodyPart',
              type: 'dropdown',
              options: {
                finger: {
                  label: 'telemed.exam.labels.finger',
                },
                hand: {
                  label: 'telemed.exam.labels.hand',
                },
                wrist: {
                  label: 'telemed.exam.labels.wrist',
                },
                forearm: {
                  label: 'telemed.exam.labels.forearm',
                },
                elbow: {
                  label: 'telemed.exam.labels.elbow',
                },
                upperarm: {
                  label: 'telemed.exam.labels.upperArm',
                },
                shoulder: {
                  label: 'telemed.exam.labels.shoulder',
                },
                knee: {
                  label: 'telemed.exam.labels.knee',
                },
                lowerleg: {
                  label: 'telemed.exam.labels.lowerLeg',
                },
                ankle: {
                  label: 'telemed.exam.labels.ankle',
                },
                foot: {
                  label: 'telemed.exam.labels.foot',
                },
                toe: {
                  label: 'telemed.exam.labels.toe',
                },
              },
            },
            finger: {
              label: 'telemed.exam.labels.finger',
              type: 'dropdown',
              enabledWhen: {
                field: 'bodyPart',
                value: 'finger',
              },
              options: {
                thumb: { label: 'telemed.exam.labels.thumb' },
                index: { label: 'telemed.exam.labels.index' },
                middle: { label: 'telemed.exam.labels.middle' },
                ring: { label: 'telemed.exam.labels.ring' },
                little: { label: 'telemed.exam.labels.little' },
              },
            },
            toe: {
              label: 'telemed.exam.labels.toe',
              type: 'dropdown',
              enabledWhen: {
                field: 'bodyPart',
                value: 'toe',
              },
              options: {
                great: { label: 'telemed.exam.labels.first' },
                second: { label: 'telemed.exam.labels.second' },
                third: { label: 'telemed.exam.labels.third' },
                fourth: { label: 'telemed.exam.labels.fourth' },
                fifth: { label: 'telemed.exam.labels.fifth' },
              },
            },
            abnormal: {
              label: 'telemed.exam.labels.abnormal',
              type: 'dropdown',
              options: {
                swelling: { label: 'telemed.exam.labels.swelling' },
                deformity: { label: 'telemed.exam.labels.deformity' },
                bruising: { label: 'telemed.exam.labels.bruising' },
                ableToBearWeight: { label: 'telemed.exam.labels.ableToBearWeight' },
                decreasedrom: { label: 'telemed.exam.labels.decreasedRom' },
              },
            },
          },
        },
      },
      comment: { 'musculoskeletal-comment': { label: 'telemed.exam.labels.musculoskeletalComment', type: 'text' } },
    },
  },
  neurological: {
    label: 'telemed.exam.labels.neurological',
    components: {
      normal: {
        'normal-mental-status': {
          label: 'telemed.exam.labels.normalMentalStatus',
          defaultValue: true,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Well in self (finding)'),
        },
      },
      abnormal: {},
      comment: {
        'neurological-comment': {
          label: 'telemed.exam.labels.neurologicalComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Neurological finding (finding)'),
        },
      },
    },
  },
  psych: {
    label: 'telemed.exam.labels.psychiatric',
    components: {
      normal: {
        'normal-affect': {
          label: 'telemed.exam.labels.normalAffect',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Level of mood - normal (finding)'),
        },
        'good-eye-contact': {
          label: 'telemed.exam.labels.goodEyeContact',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Maintains good eye contact (finding)'),
        },
      },
      abnormal: {
        'depressed-affect': {
          label: 'telemed.exam.labels.depressedAffect',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Depressed mood (finding)'),
        },
        'poor-eye-contact': {
          label: 'telemed.exam.labels.poorEyeContact',
          defaultValue: false,
          type: 'checkbox',
          code: createCodeableConcept(undefined, 'Poor eye contact (finding)'),
        },
      },
      comment: {
        'psych-comment': {
          label: 'telemed.exam.labels.psychComment',
          type: 'text',
          code: createCodeableConcept(undefined, 'Psychological finding (finding)'),
        },
      },
    },
  },
};
